"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var swr_hooks_1 = require("@l2p/swr-hooks");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var HelpDesk = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var config = (0, swr_hooks_1.useConfig)();
    var _a = (0, swr_hooks_1.useHelpDeskState)(), helpDeskStatus = _a.helpDeskStatus, changeHelpDeskStatus = _a.changeHelpDeskStatus;
    if (!helpDeskStatus ||
        !(config === null || config === void 0 ? void 0 : config.helpDeskLicense) ||
        !(config === null || config === void 0 ? void 0 : config.helpDeskContactFormID))
        return null;
    return (react_1.default.createElement(ui_components_1.Modal, { width: "525px", height: "660px", padding: "12px", saveSize: true, onClose: function () {
            changeHelpDeskStatus(false);
        } },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('supportService')),
        react_1.default.createElement("iframe", { sandbox: "allow-scripts allow-popups allow-forms allow-same-origin", width: "100%", height: "100%", style: {
                border: '0',
                overflow: 'hidden',
                overflowX: 'auto',
                height: 'calc(100% - 48px)',
            }, src: "https://forms.helpdesk.com?licenseID=".concat(config.helpDeskLicense, "&contactFormID=").concat(config.helpDeskContactFormID) })));
};
exports.default = HelpDesk;
